import './index.css';
import { ChakraProvider } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { DndProvider } from 'react-dnd-multi-backend';
import { PresetConverter } from "./pages/converter/PresetConverter";
import theme from './theme';
import { I18nextProvider } from 'react-i18next';
import i18n from './utils/i18n';
import { HTML5toTouch } from 'rdndmb-html5-to-touch';

const App = () => {
  // Remove 'elementor-kit-*' class from the body, to prevent weird styling stuff
  // Set HTML font size to 1em
  useEffect(() => {
    const body = document.body;
    const classes = body.className.split(' ');
    const newClasses = classes.filter((c) => !c.startsWith('elementor-kit-'));
    body.className = newClasses.join(' ');

    const html = document.documentElement;
    html.style.fontSize = '1em';
  }, []);

  return (
    <React.StrictMode>
      <ChakraProvider theme={theme}>
        {/* Support both touch and click input events */}
        <DndProvider options={HTML5toTouch}>
          <I18nextProvider i18n={i18n}>
            <PresetConverter />
          </I18nextProvider>
        </DndProvider>
      </ChakraProvider>
    </React.StrictMode>
  )
};

export default App;

